/**
 * AddToPipelineDialog — public entry point for the reusable
 * pick-pipeline-and-stage dialog (SE-5499, AC5).
 *
 * Reusable by construction: the board and stage are chosen from props/state
 * (an optional `boardId` prop skips the board picker for a future on-board call
 * site), and nothing reaches into open-board context — so a new surface wires a
 * trigger, not a rebuild.
 * @module features/player-kanban/components/organisms/AddToPipelineDialog
 */

export { default } from "./AddToPipelineDialogContainer";
export type { AddToPipelineDialogContainerProps as AddToPipelineDialogProps } from "./AddToPipelineDialogContainer";
export type {
  PipelineBoardOption,
  PipelineStageOption,
} from "./AddToPipelineDialogView";
